import CustomFetch from "components/API/customFetch";

const EMPTY_BUDGET_ID = "00000000-0000-0000-0000-000000000000";

export const hasPersistedBudget = (budget) => Boolean(budget?.id && budget.id !== EMPTY_BUDGET_ID);

export const getBudget = async (referenceMonth) => {
  const url = new URL(`${process.env.REACT_APP_API}/Budget`);

  if (referenceMonth != null) {
    url.searchParams.append("referenceMonth", referenceMonth);
  }

  const response = await CustomFetch(url, { method: "GET" });

  if (!response.ok) {
    throw new Error("Erro ao carregar orçamento.");
  }

  return response.json();
};

export const getBudgets = async () => {
  const response = await CustomFetch(`${process.env.REACT_APP_API}/Budget/list`, { method: "GET" });

  if (!response.ok) {
    throw new Error("Erro ao carregar orçamentos.");
  }

  return response.json();
};

export const upsertBudget = async (requestBody) => {
  const response = await CustomFetch(`${process.env.REACT_APP_API}/Budget`, {
    method: "POST",
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error("Erro ao salvar orçamento.");
  }

  return response.json();
};

export const deleteBudget = async (referenceMonth) => {
  const url = new URL(`${process.env.REACT_APP_API}/Budget`);

  if (referenceMonth != null) {
    url.searchParams.append("referenceMonth", referenceMonth);
  }

  const response = await CustomFetch(url, { method: "DELETE" });

  if (!response.ok) {
    throw new Error("Erro ao resetar orçamento.");
  }

  return true;
};
